module.exports = __webpack_public_path__ + "img/loading.0327c8ce.svg";